/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-26 15:27:03
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-01-30 16:17:42
 * @FilePath: /knit-web/src/locale/en-US/notification.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  notification: {
    invitationAccepted: 'Invitation accepted',
    invitationRejected: 'Invitation rejected',
    memberJoinedWorkspace: 'Member Joined Workspace',
    invitationDeclined: 'Invitation Declined',
    memberJoinedContent:
      '{username} has accepted the invitation and joined the workspace {workspace_name}. They now have access to workspace resources.',
    invitationDeclinedContent:
      '{username} has declined the invitation to join the workspace {workspace_name}.',
    viewDetails: 'View details',
    memberLeftWorkspace: 'Member Left Workspace',
    memberLeftContent:
      '{username} has left the workspace {workspace_name} and no longer has access to its resources.',
    acceptInvitationTitle: 'Accept Invitation?',
    acceptInvitationMessage:
      "You're about to join the workspace {workspaceName}. You'll gain access to its resources.",
    declineInvitationTitle: 'Decline Invitation?',
    declineInvitationMessage: `If you decline, you won't be able to access {workspaceName} unless you're invited again.`,
    joinedWorkspaceTitle: "You've Joined the Workspace",
    joinedWorkspaceMessage:
      'You can now collaborate with your team and access all available resources.',
    backToMessages: 'Back to Messages',
    goToWorkspace: 'Go to Workspace',
    accept: 'Accept',
    decline: 'Decline',
    cancel: 'Cancel',
    creditInsufficientBanResourceTitle: 'Database Instance Suspended',
    creditInsufficientBanResourceContent:
      'Your instance {instance_name} has been suspended due to insufficient credits. Please add credits to restore access.',
    creditUnbanResourceTitle: 'Database Instance Restored',
    creditUnbanResourceContent:
      'Your instance(s) {instance_names} have been restored successfully. Credits are now sufficient.',
    fetchListFailed: 'Failed to fetch notification list',
    markReadFailed: 'Failed to mark as read',
    acceptInvitationFailed: 'Failed to accept invitation',
    declineInvitationFailed: 'Failed to decline invitation',
  },
};
